import type { Clock } from '../types';

/** Real time. The demo clock (with its persisted offset) must never leak into live data. */
export function createRealClock(): Clock {
  return {
    now: () => Date.now(), nowIso: () => new Date().toISOString(), advance() {}, setNow() {}, reset() {}, offsetMs: () => 0,
    subscribe: () => () => undefined,
  };
}
